import store from '../index';
import { sendPost, sendPostByDfGw } from '../../utils/request';
import * as type from '../constants/ActionTypes';

export const fetchSelectCity = (data) => (
  sendPostByDfGw('/location/area/getcitylist', data, true).then((res) => {
    const newData = transformCities(res)
    // 把想要处理的数据 给reducer
    store.dispatch({ payload: newData, type: type.SELECT_CITY });
    return newData;
  })
);
export const fetchGeoLocation = (data) => (
  sendPost('/trade/cityContract/getCityLocation', data).then((res) => {
    // 把想要处理的数据 给reducer
    store.dispatch({ payload: res, type: type.GEO_LOCATION });
    return res;
  })
);

/**
 * 格式化城市数据
 * @param res 
 * @returns 
 */
function transformCities(res) {
  const { data } = res;

  if (!data) {
    console.error('数据格式错误或缺少必要字段');
    return res; // 保持原始数据结构不变
  }

  // 抽取一个通用的映射函数
  const mapCityList = (list) =>
    list?.map((item) => ({
      ...item,
      cityId: item.id,
      name: item.cityName,
      pinyin: item.pinyin,
      first: item.aleph,
    }));

  return {
    ...res, // 保持原有的其他字段
    ...data,
    cityList: mapCityList(data.cityList) ?? data.cityList,
    historyCities: mapCityList(data.historyCities) ?? data.historyCities,
    hotCities: mapCityList(data.hotCities) ?? data.hotCities,
  };
}